import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";

export default function AdminRoute({ children }) {
  // null = checking, false = unauthenticated, true = ok
  const [ok, setOk] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      const t = localStorage.getItem("admin_token");
      if (!t) { if (!cancelled) setOk(false); return; }
      try {
        await api.get("/admin/auth/me");
        if (!cancelled) setOk(true);
      } catch {
        localStorage.removeItem("admin_token");
        if (!cancelled) setOk(false);
      }
    };
    check();
    return () => { cancelled = true; };
  }, []);

  if (ok === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400 text-sm">
        Yükleniyor…
      </div>
    );
  }
  if (!ok) return <Navigate to="/admin/login" replace />;
  return children;
}
